"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.COMPONENT_NAME = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.constants");

var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.common");

var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.custom-link"));

var _gerenciatdUnifiedicons = _interopRequireDefault(require("@bit/gerenciatd.unifiedicons.svg-icon-loader"));

var _gerenciatdUnifiedcomponents2 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.text-info"));

var _gerenciatdUnifiedcomponents3 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.image"));

var _gerenciatdUtils3 = require("@bit/gerenciatd.utils.tagging");

require("./lightbox.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const COMPONENT_NAME = 'cms-lightbox';
exports.COMPONENT_NAME = COMPONENT_NAME;

class Lightbox extends _react.Component {
  static show() {
    if (!Lightbox.modalShown) {
      Lightbox.__singletonRef.__show();

      Lightbox.modalShown = true;
    }
  }

  static hide() {
    Lightbox.__singletonRef.__hide();
  }

  constructor(props) {
    super(props);

    _defineProperty(this, "openModal", () => {
      const {
        components,
        visible,
        taggingInfo
      } = this.props;
      const {
        timeOut
      } = this.props;
      let {
        expireDate
      } = this.props;
      const navigator = (0, _gerenciatdUtils2.getDeviceInfo)();

      if (navigator.browser.name === 'Safari') {
        expireDate = expireDate.replace(/-/g, '/');
      }

      const deadline = expireDate ? new Date(expireDate) : null;
      const currentdate = new Date(Date.now());

      if (visible && (!deadline || deadline > currentdate) && components['Modal-1']) {
        const modalTaggingInfo = _objectSpread(_objectSpread({}, taggingInfo), {}, {
          componentContent: _gerenciatdUtils3.LIGHT_BOX_CONTENT.CLICK_OUTSIDE
        });

        if (!modalTaggingInfo.componentName) {
          modalTaggingInfo.componentName = COMPONENT_NAME;
        }

        this.props.singleton.setModalProps(_objectSpread(_objectSpread({}, components['Modal-1']), {}, {
          taggingInfoWhenClickingOutside: modalTaggingInfo
        }));
        const Component2Mount = this.contentModal();
        this.props.singleton.setContent(Component2Mount);
        this.props.singleton.show();

        if (timeOut) {
          this.countGif();
        }
      }
    });

    _defineProperty(this, "closeModal", () => {
      this.props.singleton.setModalProps({
        show: false
      });
    });

    _defineProperty(this, "contentModal", () => {
      const {
        backgroundColor,
        components,
        taggingInfo
      } = this.props;
      const cssBG = ` bgColor--${backgroundColor}`;

      if (!components) {
        return null;
      }

      const finalTaggingInfo = _objectSpread({}, taggingInfo);

      if (!taggingInfo.componentName) {
        finalTaggingInfo.componentName = COMPONENT_NAME;
      }

      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "lightbox",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
          className: "lightbox__close",
          onClick: this.closeModal,
          taggingInfo: _objectSpread(_objectSpread({}, finalTaggingInfo), {}, {
            componentContent: _gerenciatdUtils3.LIGHT_BOX_CONTENT.CLICK_CLOSE
          }),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedicons.default, _objectSpread({}, components['SvgIconLoader-1']))
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: `lightbox__content ${cssBG}`,
          children: [components && components['InfoText-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread({}, components['InfoText-1'])), components && components['Image-1'] && components['CustomLink-1'] && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "lightbox__content__image",
            children: [components && components['Image-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, _objectSpread(_objectSpread({}, components['Image-1']), {}, {
              className: "contentPicture"
            })), components && components['CustomLink-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread(_objectSpread({}, components['CustomLink-1']), {}, {
              isBlockElement: true,
              taggingInfo: _objectSpread(_objectSpread({}, finalTaggingInfo), {}, {
                componentContent: _gerenciatdUtils3.LIGHT_BOX_CONTENT.CLICK_INSIDE
              })
            }))]
          }), components && components['InfoText-2'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread({}, components['InfoText-2']))]
        })]
      });
    });

    _defineProperty(this, "countGif", () => {
      const {
        timeOut
      } = this.props;

      if (timeOut) {
        setTimeout(() => {
          this.closeModal();
        }, timeOut);
      }
    });

    Lightbox.__singletonRef = this;
  }

  __show() {
    const {
      mobileEnabled
    } = this.props;
    const currentDevice = (0, _gerenciatdUtils2.getDeviceKindDependsOnViewPort)();

    if (mobileEnabled && currentDevice === _gerenciatdUtils.DEVICES.MOBILE || currentDevice === _gerenciatdUtils.DEVICES.PC) {
      this.openModal();
    }
  }

  __hide() {
    this.closeModal();
  }

  render() {
    return null;
  }

}

_defineProperty(Lightbox, "modalShown", false);

Lightbox.WaitingComponent = () => null;

Lightbox.propTypes = {
  backgroundColor: _propTypes.default.oneOf(['white', 'transparent']),
  taggingInfo: _propTypes.default.object.isRequired,
  mobileEnabled: _propTypes.default.bool
};
Lightbox.defaultProps = {
  visible: true,
  backgroundColor: 'transparent',
  mobileEnabled: true
};
var _default = Lightbox;
exports.default = _default;

//# sourceMappingURL=index.js.map